export default __webpack_public_path__ + "static/media/truckB.bb02efc1.svg";